import zod from 'helpers/zod';
export const loginSchema = zod.object({
   username: zod
      .string({
         required_error: 'required_error',
         invalid_type_error: 'invalid_type_error',
      })
      .min(1, { message: 'required_error' }),
   password: zod
      .string({
         required_error: 'required_error',
         invalid_type_error: 'invalid_type_error',
      })
      .min(1, { message: 'required_error' }),
});

export const registerSchema = zod
   .object({
      email: zod
         .string({
            required_error: 'required_error',
            invalid_type_error: 'invalid_type_error',
         })
         .min(1, { message: 'required_error' })
         .email({ message: 'invalid_email' }),
      password: zod
         .string({
            required_error: 'required_error',
            invalid_type_error: 'invalid_type_error',
         })
         .min(8, { message: 'password_min_8_character' }),
      password_confirmation: zod
         .string({
            required_error: 'required_error',
            invalid_type_error: 'invalid_type_error',
         })
         .min(1, { message: 'invalid_type_error' }),
      phone_number: zod
         .string({
            required_error: 'required_error',
            invalid_type_error: 'invalid_type_error',
         })
         .min(1, { message: 'required_error' })
         .regex(/998\d{9}/, {
            message: 'invalid_phone',
         }),
   })
   .refine(
      values => {
         return values.password === values.password_confirmation;
      },
      {
         message: 'invalid_password_conifmation',
         path: ['password_confirmation'],
      },
   );
